import { Component, Input, OnInit } from '@angular/core';
import { CvDto } from 'src/app/services/api-client/models';
import { ActivatedRoute } from '@angular/router';
import { DirtyComponent } from 'src/app/guards/dirty-component';

@Component({
  selector: 'app-cv-detail',
  templateUrl: './cv-detail.component.html',
  styleUrls: ['./cv-detail.component.scss']
})

export class CvDetailComponent implements OnInit, DirtyComponent {

  @Input() cv: CvDto;

  dirty: boolean;
  isMyCvDetail = false;

  constructor(
    private activatedRoute: ActivatedRoute
  ) {}
  itemsOfDirtyComponent: number[] = new Array(3);

  isDirty(): boolean {
    return this.dirty;
  }

  ngOnInit(): void {
    this.cv = this.activatedRoute.snapshot.data['cv'];
    const activatedRoutePath = this.activatedRoute.snapshot.routeConfig.path;
    this.isMyCvDetail = activatedRoutePath.endsWith('cv-detail/de') || activatedRoutePath.endsWith('cv-detail/en') ;
  }

  handleCVChange(cv: CvDto){
    this.cv = cv;
  }

  parseObject(obj: any) {
    for(var key in obj) {
      if(obj[key] instanceof Object) {
        this.parseObject(obj[key]);
      } else {
        console.log( key + ", value: " + obj[key])
      }
    }
  }

  markAsDirty(dirtyItems: boolean[]) {
    let dirtyCounter=0;
    dirtyItems.forEach((dirty, i )=> {
      if (dirty) {
        this.itemsOfDirtyComponent[i] = i;
        dirtyCounter++;
      } else {
        this.itemsOfDirtyComponent[i] = null;
      }
    });

    this.dirty = (dirtyCounter > 0) ? true : false;
  }

}
